import axios from 'axios';

export async function email_authentication(endpoint, config) {
  let results = await axios.post(endpoint, config);

  return results.data;
}

export async function po_service(endpoint, config) {
  let results = await axios(endpoint, config);
  return results.data;
}

export async function po_master_service(
  PONO_endpoint,
  // WONO_endpoint,
  CustomerPO_endpoint,
  // BIN_endpoint,
  config
) {
  const [PurchaseOrderNo, CustomerPos,] = await axios.all([
    axios.get(PONO_endpoint, config),
   
    axios.get(CustomerPO_endpoint, config),
    
  ]);
  return {
    PurchaseOrderNo: PurchaseOrderNo.data.Records,
  
    CustomerPos: CustomerPos.data.Records,
   
  };
}

// Secondary GRN Master Data
export async function secondary_grn_master_service(
  PONO_endpoint,
 
  config
) {
  const [PurchaseOrderNo, WorkOrderNo] = await axios.all([
    axios.get(PONO_endpoint, config),
    
  ]);
  return {
    PurchaseOrderNo: PurchaseOrderNo.data.Records,
    
  };
}

// Diversion Data
export async function diversion_master_service(
  PrimaryGRNNo_endpoint,
  DiversionID_endpoint,
  config
) {
  const [PrimaryGRNs, DiversionIDs] = await axios.all([
    axios.get(PrimaryGRNNo_endpoint, config),
    axios.get(DiversionID_endpoint, config),
  ]);

  return {
    PrimaryGRNs: PrimaryGRNs.data.Records,
    DiversionIDs: DiversionIDs.data.Records,
  };
}

export function execPostRequestsDownloadFile(
  endpoint,
  filename,
  configheaders,
  postdata
) {
  axios({
    url: endpoint, // Interface name
    method: 'post',
    headers: configheaders,
    data: postdata,
    responseType: 'blob',
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      });
      const aEle = document.createElement('a'); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link

      window.open(href);
      //   aEle.href = href;
      //   aEle.download = filename; // File name after download
      //   document.body.appendChild(aEle);
      //   aEle.click(); // Click to download
      //   document.body.removeChild(aEle); // Download complete remove element
      //   window.URL.revokeObjectURL(href); // Release blob object
    })
    .catch((err) => console.log(err));
}

export function execPostRequestsDownloadExcelFile(
  endpoint,
  filename,
  configheaders,
  postdata
) {
  axios({
    url: endpoint, // Interface name
    method: 'post',
    headers: configheaders,
    data: postdata,
    responseType: 'blob',
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
      });
      const aEle = document.createElement('a'); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
      //window.open(href);
    })
    .catch((err) => console.log(err));
}


export function execGetRequestsDownloadFile(endpoint, filename, configheaders) {
  axios({
    url: endpoint, // Interface name
    method: "get",
    headers: configheaders,

    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
    .catch((err) => console.log(err));
}

export function execGetRequestsDownloadCSVFile(endpoint, filename, configheaders,params) {
  axios({
    url: endpoint, // Interface name
    method: "get",
    headers: configheaders,
    params: params,
    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type:
          "text/csv;charset=utf-8;",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
    .catch((err) => console.log(err));
}


export function execPostRequestsDownloadCSVFile(endpoint, filename, configheaders,params) {
  axios({
    url: endpoint, // Interface name
    method: "post",
    headers: configheaders,
    data: params,
    responseType: "blob",
  })
    .then(function (response) {
      const blob = new Blob([response.data], {
        type:
          "text/csv;charset=utf-8;",
      });
      const aEle = document.createElement("a"); // Create a label
      const href = window.URL.createObjectURL(blob); // Create downloaded link
      aEle.href = href;
      aEle.download = filename; // File name after download
      document.body.appendChild(aEle);
      aEle.click(); // Click to download
      document.body.removeChild(aEle); // Download complete remove element
      window.URL.revokeObjectURL(href); // Release blob object
    })
    .catch((err) => console.log(err));
}